<script>
export default {
  name: "DidoMillesimeTabDownload",
};
</script>

<script setup>
import { ref } from "vue";
import DidoMillesimeDownloadFull from "../download/Full.vue";
import DidoMillesimeDownloadCustom from "../download/Custom.vue";

// define Props
const props = defineProps({
  apiUrl: { type: String, required: true },
  rid: { type: String, required: true },
  millesime: { type: String, required: true },
  infos: { type: Object, required: true },
});

// define reactive data for state of download tabs
const isFull = ref(true);
</script>

<template>
  <div>
    <div>
      <div v-if="isFull">
        <div>
          Télécharger ici l'ensemble des données dans différents formats
        </div>
        <div class="text-small text-italic row-start-center">
          Vous pouvez également
          <QBtn
            type="a"
            label="personnaliser les données"
            title="Personnaliser le téléchargement des données"
            flat
            dense
            no-caps
            color="primary"
            class="text-underline text-small"
            @click="isFull = !isFull"
          />
          que vous souhaitez télécharger
        </div>
        <DidoMillesimeDownloadFull
          :api-url="props.apiUrl"
          :rid="props.rid"
          :millesime="props.millesime"
          :infos="props.infos"
        />
      </div>
      <div v-else>
        <div>Personnaliser ici le téléchargement de vos données</div>
        <div class="text-small text-italic row-start-center">
          Vous pouvez également
          <QBtn
            type="a"
            label="télécharger les données complètes"
            title="Accéder au téléchargement des données complètes"
            flat
            dense
            no-caps
            color="primary"
            class="text-underline text-small"
            @click="isFull = !isFull"
          />
        </div>
        <DidoMillesimeDownloadCustom
          :api-url="props.apiUrl"
          :rid="props.rid"
          :millesime="props.millesime"
          :infos="props.infos"
        />
      </div>
    </div>
  </div>
</template>
